<template>
	<div class="careers__list">
		<h3 v-text="title"></h3>

		<div class="careers__table">
			<div class="careers__table__header">
				<div class="cell">Position</div>
				<div class="cell">Qualifications</div>
				<div class="cell">Experience</div>
				<div class="cell">Overview</div>
				<div class="cell"></div>
			</div>

			<div class="careers__table__body">
				<div
					class="careers__table__body__row"
					v-for="(career, index) in JSON.parse(careers)"
					:key="index"
				>
					<div class="mob-header">Position</div>
					<careers-list-cell :text="career.position"></careers-list-cell>
					<div class="mob-header">
						Qualifications
					</div>
					<careers-list-cell :text="career.qualifications"></careers-list-cell>
					<div class="mob-header">Experience</div>
					<careers-list-cell :text="career.experience"></careers-list-cell>
					<div class="mob-header">Overview</div>
					<careers-list-cell :text="career.overview"></careers-list-cell>
					<a :href="career.apply" class="cell-button button careers">Apply</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import CareersListCell from '../vue/CareersListCell.vue';

export default {
	data() {
		return {
			window: {
				width: 0,
				height: 0,
			},
		};
	},

	props: {
		title: {},
		careers: {},
	},

	computed: {},

	watch: {},

	methods: {
		handleResize() {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;
		},
	},

	components: {
		CareersListCell,
	},

	created() {
		window.addEventListener('load', this.handleResize);
		window.addEventListener('resize', this.handleResize);
	},
	destroyed() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.careers__list {
	grid-column: 1 / span 12;
}

.careers__table {
	display: grid;
	grid-template-columns: 1fr;
	row-gap: 1rem;
	grid-column: span 1;

	&__header {
		display: grid;
		grid-template-columns: repeat(5, 1fr);
		column-gap: 1rem;
		row-gap: 1rem;
		border-bottom: 1px solid $signs-teal;
		padding-bottom: 1rem;
		grid-column: span 1;

		@media (max-width: 1366px) {
			display: none;
		}

		.cell {
			grid-column: span 1;
			font-weight: bold;
			height: 20px;
		}
	}

	&__body {
		display: grid;
		grid-template-columns: 1fr;
		grid-column: span 1;
		row-gap: 1rem;

		&__row {
			grid-column: 1 / span 5;
			display: grid;
			grid-template-columns: repeat(5, 1fr);
			column-gap: 1rem;
			row-gap: 1rem;

			@media (max-width: 1366px) {
				grid-template-columns: 1fr;
			}

			.mob-header {
				border-bottom: 1px solid $signs-teal;
				padding-bottom: 1rem;
				font-weight: bold;
				display: none;

				@media (max-width: 1366px) {
					grid-template-columns: 1fr;
					display: block;
				}
			}

			.cell-button {
				grid-column: span 1;
				display: flex;
				justify-content: center;
				align-items: center;

				@media (max-width: 1366px) {
					margin-bottom: 1rem;
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/CareersList.vue